<template>
  <div class="w-full base-skeleton">
    <div
      v-for="(_, index) in Array(actualLines)"
      :key="index"
      class="bg-grey-200 rounded animate-shine"
      :style="{
        width: getRandomWidth(),
        height: `${height}px`,
        marginBottom: index === actualLines - 1 ? '0' : `${spacing}px`
      }"
    />
  </div>
</template>

<script setup>
import { computed, defineProps } from 'vue';

const props = defineProps({
  lines: {
    type: Number,
    default: 1,
  },
  minWidthPercent: {
    type: Number,
    default: 30,
  },
  maxWidthPercent: {
    type: Number,
    default: 100,
  },
  height: {
    type: Number,
    default: 16,
  },
  spacing: {
    type: Number,
    default: 8,
  },
});

// Ensure at least 1 line
const actualLines = computed(() => Math.max(1, props.lines));

// Generate random width for each line
const getRandomWidth = () => {
  const randomPercent = Math.floor(
    Math.random() * (props.maxWidthPercent - props.minWidthPercent + 1) + props.minWidthPercent,
  );
  return `${randomPercent}%`;
};
</script>

<style lang="scss">
@use "@sass/base/keyframes";
@use "@sass/design-system/variables" as ds-variables;

.base-skeleton {
  .animate-shine {
    animation: shine 1.5s linear infinite;
    background-image: linear-gradient(
      90deg,
      ds-variables.$grey-200 0%,
      ds-variables.$grey-300 50%,
      ds-variables.$grey-200 100%
    );
    background-size: 200% 100%;
  }
}
</style>
